// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'f4b745d3ef14e9b688889af2d18db6b3cf365f64';
export const BUILD_NUMBER = '180';
export const BUILD_TIMESTAMP = '2026-07-01T02:14:05.213Z';
